<template>
  <v-layout wrap>
    <v-flex xs12 mb-2 v-if="length > 150">
      <v-text-field
        box
        :hint="field.guidance"
        :disabled="readonly"
        :label="fieldLabel"
        :rules="activeRules"
        v-on:blur="blurred()"
        v-model="text"
      ></v-text-field>
    </v-flex>
    <v-flex v-if="length <= 150">
      <v-text-field box :label="fieldLabel" :disabled="readonly" :rules="activeRules" v-model="text" v-on:blur="blurred()">
        <v-tooltip v-if="length > 0" slot="append" top color="secondary">
          <v-icon slot="activator" color="secondary" dark>help</v-icon>
          <span style="padding:15px; display:block; max-width:400px">{{field.guidance}}</span>
        </v-tooltip>
      </v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import Helpers from "@/helpers.js"

export default {
  name: "text-field",
  data: () => ({
    rules: {
      required: value => !!value || "Required.",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || "Invalid e-mail."
      }
    }
  }),
  props: {
    field: {
      type: Object
    },
    data: {
      type: String
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    }
  },
  methods: {
    blurred() {
      this.$emit("blurred", {
        field: this.field.name,
        data: this.text,
        row: this.row
      })
    }
  },
  computed: {
    activeRules() {
      const results = []
      if (this.field.type === "email_address") {
        results.push(this.rules.email)
      }
      if (this.field.required) {
        results.push(this.rules.required)
      }
      return results
    },
    fieldLabel() {
      return this.field.display_name
        ? this.field.display_name
        : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    length() {
      if (this.field && this.field.guidance) {
        return this.field.guidance.length
      } else {
        return 0
      }
    },
    text: {
      get() {
        if (this.data) {
          return this.data
        } else {
          if (this.field && this.field.default_value) {
            return this.field.default_value
          } else {
            return ""
          }
        }
      },
      set(value) {
        this.$emit("update-item", {
          field: this.field.name,
          data: value,
          row: this.row
        })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) {
        readonly = this.field.readonly
      }
      return readonly
    }
  }
}
</script>
